  // --- Переменные для управления анимациями title ---
  let titleHideTween = null;
  let titleShowTween = null;
if (typeof gsap !== "undefined") {
  document.addEventListener("DOMContentLoaded", function () {
    $(".faq__item").click(function () {
      const $item = $(this);
      const $answer = $item.find(".faq__answer");

      // Закрываем все остальные ответы
      $(".faq__item")
        .not($item)
        .removeClass("faq__item--open")
        .find(".faq__answer")
        .slideUp(400);

      // Открываем/закрываем текущий
      $answer.slideToggle(400, function () {
        $item.toggleClass("faq__item--open", $answer.is(":visible"));
      });
    });

    gsap.registerPlugin(ScrollToPlugin);
    gsap.registerPlugin(SplitText);
    const welcomeSection = document.querySelector(".welcome");
    const revolutionSection = document.querySelector(".revolution");
    console.log(revolutionSection);
    let scrolled = false;

    SplitText.create(".split", {
      type: "words",
      mask: "words",
      autoSplit: true,
      onSplit(self) {
        return gsap.from(self.words, {
          duration: 1,
          y: 100,
          autoAlpha: 0,
          stagger: 0.08,
        });
      },
    });

    SplitText.create(".split-fade", {
      type: "words",
      autoSplit: false,
      onSplit(self) {
        return gsap.from(self.words, {
          duration: 1.2,
          y: 0,
          autoAlpha: 0,
          stagger: 0.2,
        });
      },
    });

    // --- Функция появления welcome-секции ---
    function showWelcomeSection() {
      // Сбросить стили, которые были изменены при hide-анимации
      // ОТМЕНЯЕМ анимацию скрытия, если она ещё идёт
      if (titleHideTween) {
        titleHideTween.kill();
        titleHideTween = null;
      }
      // ОТМЕНЯЕМ анимацию появления, если она ещё идёт
      if (titleShowTween) {
        titleShowTween.kill();
        titleShowTween = null;
      }
      gsap.set(".welcome .title", { clearProps: "all" });
      gsap.set(
        [
          ".welcome__waves",
          ".welcome__circles",
          ".welcome__brain",
          ".welcome__light",
          ".welcome .dots-bg",
        ],
        { clearProps: "all" }
      );
      gsap.set(".welcome__hand", { clearProps: "all" });
      gsap.set(".welcome .card", { clearProps: "all" });

      // SplitText-анимации для текста
      SplitText.create(".split", {
        type: "words",
        mask: "words",
        autoSplit: true,
        onSplit(self) {
          return gsap.fromTo(
            self.words,
            {
              y: 100,
              autoAlpha: 0,
            },
            {
              duration: 1,
              y: 0,
              autoAlpha: 1,
              stagger: 0.08,
              ease: "power2.out",
            }
          );
        },
      });

      SplitText.create(".split-fade", {
        type: "words",
        autoSplit: false,
        onSplit(self) {
          return gsap.fromTo(
            self.words,
            {
              autoAlpha: 0,
            },
            {
              duration: 1.2,
              autoAlpha: 1,
              stagger: 0.2,
              ease: "power2.out",
            }
          );
        },
      });

      // Анимация появления title (управляемая tween)
      titleShowTween = gsap.fromTo(
        ".welcome .title",
        { y: -100, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 1, ease: "power2.out", clearProps: "all", onComplete: () => { titleShowTween = null; } }
      );

      // Фоны и рука fade-in/scale-in
      gsap.fromTo(
        [
          ".welcome__waves",
          ".welcome__circles",
          ".welcome__brain",
          ".welcome__light",
          ".welcome .dots-bg",
        ],
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 1.5, ease: "power2.out" }
      );
      gsap.fromTo(
        [".welcome__circles"],
        { autoAlpha: 0, scale: 1.6 },
        { autoAlpha: 1, duration: 1.5, ease: "power2.out" }
      );
      gsap.fromTo(
        ".welcome__hand",
        { autoAlpha: 0, y: 100 },
        {
          autoAlpha: 1,
          scale: 1,
          duration: 1,
          y: 0,
          delay: 0.5,
          ease: "power2.out",
        }
      );
      // Карточка
      gsap.fromTo(
        ".welcome .card",
        { autoAlpha: 0, scale: 1.1, y: -100 },
        { autoAlpha: 1, scale: 1, y: 0, duration: 1, ease: "power2.out" }
      );
    }

    if (welcomeSection && revolutionSection) {
      let lastScrollY = window.scrollY;
      let welcomeAnimated = false; // флаг для однократной анимации
      window.addEventListener("scroll", function () {
        const currentScrollY = window.scrollY;
        // Получаем нижнюю границу секции welcome
        const welcomeBottom =
          welcomeSection.getBoundingClientRect().bottom + window.scrollY;
        const welcomeRect = welcomeSection.getBoundingClientRect();
        const welcomeBottomViewport = welcomeRect.bottom; // Нижняя граница относительно вьюпорта

        if (window.innerWidth > 768) {
          // Десктопная логика
          // Если скроллим вниз с самого верха (lastScrollY === 0) и welcomeAnimated == false
          if (currentScrollY > lastScrollY) {
            if (lastScrollY === 0 && !scrolled && !welcomeAnimated) {
              scrolled = true;
              welcomeAnimated = true;

              // ОТМЕНЯЕМ анимацию появления, если она ещё идёт
              if (titleShowTween) {
                titleShowTween.kill();
                titleShowTween = null;
              }
              // ОТМЕНЯЕМ анимацию скрытия, если она ещё идёт
              if (titleHideTween) {
                titleHideTween.kill();
                titleHideTween = null;
              }

              // Анимация исчезновения welcome
              const tl = gsap.timeline();

              // 1. Анимация .title (fade out + up)
              titleHideTween = tl.to(
                ".welcome .title",
                {
                  duration: 1,
                  y: -100,
                  autoAlpha: 0,
                  ease: "power2.in",
                  onComplete: () => { titleHideTween = null; },
                },
                0
              );

              // 2. Анимация фонов
              tl.to(
                [
                  ".welcome__waves",
                  ".welcome__circles",
                  ".welcome__brain",
                  ".welcome__light",
                  ".welcome .dots-bg",
                ],
                {
                  duration: 1.5,
                  autoAlpha: 0,
                  ease: "power2.in",
                },
                0
              );

              // 3. Анимация .welcome__hand (scale out + fade out, задержка 1 секунда)
              tl.to(
                ".welcome__hand",
                {
                  duration: 1.2,
                  scale: 0.8,
                  autoAlpha: 0,
                  ease: "power2.in",
                },
                0
              );

              // 4. Анимация .card (scale up, затем вверх и fade out)
              tl.to(
                ".welcome .card",
                {
                  duration: 0.5,
                  scale: 1.1,
                  ease: "power1.out",
                },
                0
              );
              tl.to(
                ".welcome .card",
                {
                  duration: 0.5,
                  y: -100,
                  autoAlpha: 0,
                  ease: "power2.in",
                },
                0.5
              );
            }
          } else if (currentScrollY < lastScrollY) {
            if (
              welcomeRect.top >= 0 &&
              welcomeBottomViewport <= window.innerHeight
            ) {
              scrolled = false;
              welcomeAnimated = false; // сбрасываем, чтобы цикл повторялся
              showWelcomeSection(); // ← запуск анимации появления
            }
          }
        }
        // На мобильных (<=768px) — ничего не делаем (вся логика отключена)
        lastScrollY = currentScrollY;
      });
    }
  });
} else {
  console.error("GSAP не подключен!");
}

document
  .querySelectorAll(".revolution .title h2, .revolution .title p")
  .forEach((el) => {
    el.innerHTML = el.innerHTML.replace(/\n/g, "<br>");
  });
// --- Функция появления секции revolution ---
let revolutionAnimated = false;

// Если в самом верху — скрыть элементы для анимации
document.querySelectorAll(".revolution .title h2").forEach((h2) => {
  gsap.set(h2, { y: 30, autoAlpha: 0 });
});

gsap.set(".revolution .card", { autoAlpha: 0, x: -80 });
gsap.set(".revolution .neurons", { autoAlpha: 0 });
gsap.set([".light.top", ".light.bottom"], { autoAlpha: 0 });

function showRevolutionSection() {
  if (revolutionAnimated) return;
  revolutionAnimated = true;
  gsap.set([".revolution .title h2", ".revolution .title p"], {
    clearProps: "all",
  });
  const tl = gsap.timeline();

  // Анимация ВСЕХ <h2>
  document.querySelectorAll(".revolution .title h2").forEach((h2) => {
    const h2Split = SplitText.create(h2, {
      type: "words",
      preserveSpaces: true,
    });
    tl.fromTo(
      h2Split.words,
      { y: 30, autoAlpha: 0 },
      { y: 0, autoAlpha: 1, duration: 1, stagger: 0.08, ease: "power2.out" },
      "<" // стартует сразу
    );
  });

  // Карточки .revolution .card: fade in + выезд слева (одновременно с текстом)
  tl.fromTo(
    ".revolution .card",
    { autoAlpha: 0, x: -80 },
    { autoAlpha: 1, x: 0, duration: 1, ease: "power2.out", stagger: 0.1 },
    "<" // стартует одновременно с текстом
  );

  // После текста и карточек — одновременно нейроны и свет
  tl.fromTo(
    ".revolution .neurons",
    { autoAlpha: 0 },
    { autoAlpha: 1, duration: 1.4, ease: "power2.out" },
    ">" // после предыдущих
  );
  tl.fromTo(
    [".light.top", ".light.bottom"],
    { autoAlpha: 0 },
    { autoAlpha: 1, duration: 1.4, ease: "power2.out" },
    "<" // одновременно с нейронами
  );
}

// --- Для всех экранов: запуск анимации revolution при попадании в зону видимости ---
revolutionAnimated = false; // сброс для всех
const revolutionSection = document.querySelector(".revolution");
if (revolutionSection) {
  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && !revolutionAnimated) {
          showRevolutionSection();
          observer.disconnect();
        }
      });
    },
    {
      threshold: 0.2, // 20% блока в зоне видимости
    }
  );
  observer.observe(revolutionSection);
}
